import { render } from "./CheckPointScreen.vue?vue&type=template&id=dd42e7f6"
import script from "./CheckPointScreen.vue?vue&type=script&lang=js"
export * from "./CheckPointScreen.vue?vue&type=script&lang=js"

import exportComponent from "D:\\All\\Job freelance\\CRA-brainy\\Develop\\cra-brainy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__